import React, { useState, useEffect, useRef } from 'react'

export function UseComponentVisible2(initialIsVisible) {
    const [isComponentVisible2, setIsComponentVisible2] = useState(
        initialIsVisible
    );
    const ref2 = useRef(null);

    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            setIsComponentVisible2(false);
        }
    };

    const handleClickOutside = (event) => {
        if (ref2.current && !ref2.current.contains(event.target)) {
            setIsComponentVisible2(false);
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", handleHideDropdown, true);
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("keydown", handleHideDropdown, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    })

    return { ref2, isComponentVisible2, setIsComponentVisible2 };
}